/** The message of a caught error, if it carries a text one. */
/** @boundary Reads the message off whatever was thrown. */
export function messageOfError(error: unknown): string | undefined {
    if (typeof error === "object" && error !== null && "message" in error && typeof error.message === "string") {
        return error.message
    }
    return undefined
}
